module.exports = __webpack_public_path__ + "img/icon-done.016f04c2.svg";